module.exports = __webpack_public_path__ + "static/media/boss-remember-block.3945a6b3.png";